import * as Types from '@aeppic/types'

/** An unconfigured validator preserves the legacy version policy. */
export async function supportsValidationTargetVersion(api: any, rule: Types.Document, target: Types.Document): Promise<boolean> {
  const anchor = rule.data?.targetForm as Types.Reference | undefined
  if (!anchor?.id) return true
  if (!anchor.v) throw new Error('Validation target form requires an exact version')
  if (target.f.id !== anchor.id) return false
  if (target.f.v === anchor.v) return true

  const scope = rule.data.previousVersionScope || 'NONE'
  if (scope === 'NONE') return false
  if (scope !== 'SELECTED' && scope !== 'ALL') {
    throw new Error('Unknown previous form version scope: ' + scope)
  }

  const versions: string[] = await api.getFormVersions(anchor.id)
  const targetIndex = versions.indexOf(target.f.v)
  const anchorIndex = versions.indexOf(anchor.v)
  if (targetIndex < 0 || anchorIndex < 0) {
    throw new Error('Validation form version history is incomplete')
  }
  if (targetIndex >= anchorIndex) return false
  if (scope === 'ALL') return true

  const supported = rule.data.supportedFormVersions as Types.Reference[] | undefined
  return Array.isArray(supported) && supported.some(ref => ref.id === anchor.id && ref.v === target.f.v)
}
